var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { _TypedDataEncoder } from '@ethersproject/hash';
// See https://github.com/MetaMask/eth-rpc-errors/blob/b19c8724168eec4ce3f8b1f87642f231f0dd27b2/src/error-constants.ts#L12
export var INVALID_PARAMS_CODE = -32602;
/**
 * Calls into the eth_signTypedData methods to add support for wallets with spotty EIP-712 support (eg Safepal) or without any (eg Zerion),
 * by first trying eth_signTypedData, and then falling back to either eth_signTyepdData_v4 or eth_sign.
 * The implementation is copied from ethers (and linted).
 * @see https://github.com/ethers-io/ethers.js/blob/c80fcddf50a9023486e9f9acb1848aba4c19f7b6/packages/providers/src.ts/json-rpc-provider.ts#L334
 * TODO(https://github.com/ethers-io/ethers.js/pull/3667): Remove if upstreamed.
 */
export function signTypedData(signer, domain, types, 
// Use Record<string, any> for the value to match the JsonRpcSigner._signTypedData signature.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value) {
    return __awaiter(this, void 0, void 0, function () {
        var populated, address, error_1, error_2, hash;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _TypedDataEncoder.resolveNames(domain, types, value, function (name) {
                        return signer.provider.resolveName(name);
                    })];
                case 1:
                    populated = _a.sent();
                    return [4 /*yield*/, signer.getAddress()];
                case 2:
                    address = _a.sent();
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 10, , 13]);
                    _a.label = 4;
                case 4:
                    _a.trys.push([4, 6, , 9]);
                    return [4 /*yield*/, signer.provider.send('eth_signTypedData', [
                            address.toLowerCase(),
                            JSON.stringify(_TypedDataEncoder.getPayload(populated.domain, types, populated.value)),
                        ])];
                case 5: 
                // We must try the unversioned eth_signTypedData first, because some wallets (eg SafePal) will hang on _v4.
                return [2 /*return*/, _a.sent()];
                case 6:
                    error_1 = _a.sent();
                    if (!(error_1.code === INVALID_PARAMS_CODE)) return [3 /*break*/, 8];
                    console.warn('eth_signTypedData failed, falling back to eth_signTypedData_v4:', error_1);
                    return [4 /*yield*/, signer.provider.send('eth_signTypedData_v4', [
                            address.toLowerCase(),
                            JSON.stringify(_TypedDataEncoder.getPayload(populated.domain, types, populated.value)),
                        ])];
                case 7: return [2 /*return*/, _a.sent()];
                case 8: throw error_1;
                case 9: return [3 /*break*/, 13];
                case 10:
                    error_2 = _a.sent();
                    if (!(typeof error_2.message === 'string' && error_2.message.match(/not found/i))) return [3 /*break*/, 12];
                    console.warn('eth_signTypedData_* failed, falling back to eth_sign:', error_2);
                    hash = _TypedDataEncoder.hash(populated.domain, types, populated.value);
                    return [4 /*yield*/, signer.provider.send('eth_sign', [address, hash])];
                case 11: return [2 /*return*/, _a.sent()];
                case 12: throw error_2;
                case 13: return [2 /*return*/];
            }
        });
    });
}
